import { useDispatch, useSelector } from "react-redux";
import { useCallback, useMemo } from "react";
import {
  selectSearchAndFilter,
  setFilter,
} from "../redux/slices/search&FilterSlice";

export const usePageFilter = (key, initial = null) => {
  const dispatch = useDispatch();
  const filterSlice = useSelector(selectSearchAndFilter);

  const initialValue = useMemo(() => initial, []);
  const value = filterSlice.filter[key] ?? initialValue;

  const setter = useCallback(
    (value) => dispatch(setFilter({ [key]: value })),
    [dispatch, key],
  );

  return [value, setter];
};
